import { inject } from '@angular/core';
import { Location } from '@angular/common';
import { getLangFromRouteLang } from '../helpers/get-lang-from-route-lang.function';
import { LanguageService } from '../services/language/language.service';

export function initLanguage() {
  return () => {
    const languageService = inject(LanguageService);
    const location = inject(Location);

    const routeLang = location.path().slice(1, 3);
    const lang = getLangFromRouteLang(routeLang);

    return languageService.setCurrentLang(lang);
  };
}
